<script setup lang="ts">
    defineProps<{
        message?: string;
    }>();
</script>

<template>
    <div v-show="message">
        <p class="text-destructive text-xs">
            {{ message }}
        </p>
    </div>
</template>
